export default __webpack_public_path__ + "static/media/T5-selected.7390893c.png";